import { forwardRef, useImperativeHandle, useRef } from 'react';
import styled from 'styled-components/macro';

import { rem } from '@blueprint/ui';
import { Box } from 'components/blueprint';

import { BlueprintMarkdown } from 'components/blueprint-markdown/BlueprintMarkdown';

import { Avatar } from './Avatar';
import { CoBrowseActions } from './CoBrowseActions/CoBrowseActions';
import { BaseContentBox } from './content-box/BaseContentBox';
import { ReplyMeta } from './ReplyMeta';
import { ReplyWrapper } from './ReplyWrapper';
import { QuickReplySurverActions } from './QuickReplySurverActions/QuickReplySurverActions';
import { ReplyMetaTime } from './ReplyMetaTime';

const AgentBaseContentBox = styled(BaseContentBox)`
  && p:not(:last-child) {
    margin-bottom: ${rem(15)};
  }
`;

/**
 * AgentReply
 * A template for displaying agent reply
 */
export const AgentReply = forwardRef(
  ({ name, datetime, coBrowse, isFeedbackEnable, content, answer }, ref) => {
    const containerRef = useRef(null);

    useImperativeHandle(ref, () => ({
      scrollIntoView: () => containerRef.current?.scrollIntoView(),
    }));

    return (
      <ReplyWrapper ref={containerRef}>
        <Avatar iconName="ContactLiveChat" />
        <Box>
          <ReplyMeta role={name} time={datetime} />
          <AgentBaseContentBox flexDirection="column">
            <BlueprintMarkdown markdown={answer} />
            {!!coBrowse && (
              <CoBrowseActions
                isFeedbackEnable={isFeedbackEnable}
                coBrowse={coBrowse}
              />
            )}
            {!!content && (
              <QuickReplySurverActions
                isFeedbackEnable={isFeedbackEnable}
                content={content}
                answer={answer}
              />
            )}
          </AgentBaseContentBox>
          <ReplyMetaTime datetime={datetime} />
        </Box>
      </ReplyWrapper>
    );
  },
);
